import { create } from 'zustand';

interface DebugModeState {
  isDebugMode: boolean;
  toggleDebugMode: (next?: boolean) => void;
}

const useDebugModeStore = create<DebugModeState>()((set, get) => ({
  isDebugMode: false,
  toggleDebugMode: (next?: boolean) => {
    const current = get().isDebugMode;
    set({ isDebugMode: next ?? !current });
  },
}));

export const useDebugMode = () => {
  const { isDebugMode, toggleDebugMode } = useDebugModeStore();

  return {
    isDebugMode,
    toggleDebugMode,
  };
};
